import * as React from 'react';
import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgMiscPackage = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#2D2E2E"
      fillRule="evenodd"
      d="M2 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4h-1v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9H2V5Zm17 4v10H5V9h14Zm1-2H4V5h16v2ZM9 13h6v-2H9v2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMiscPackage;
